import { useNavigate, useParams } from '@/router';

export const useEditClientUserDismiss = () => {
  const { id } = useParams('/clients/:id/users/:userId/edit');
  const navigate = useNavigate();

  return () => navigate('/clients/:id/users', { params: { id } });
};
